import { useAppContext } from '../../context/AppState/AppContext';
import PreguntasFrecuentesContainer from '../../features/PreguntasFrecuentes/PreguntasFrecuentesContainer';
import MainLayout from '../../layouts/MainLayout/MainLayout';
import './PreguntasFrecuentes.css';
const PreguntasFrecuentes = () => {
  const {jsonTexts} = useAppContext();
  const {title, description} = jsonTexts.frequentQuestions;
  const {contact} = jsonTexts;

  return (
    <>
    <MainLayout>
      <section className='preguntasFrecuentes-section'>
        <PreguntasFrecuentesContainer title={title} description={description} contact={contact}/>
        </section>
        </MainLayout>
    </>
  )
}
export default PreguntasFrecuentes